import { useCallback, useEffect, useState } from 'react';

export function useSearchParamQuery() {
  const [urlSearchParams, setUrlSearchParams] = useState(
    new URLSearchParams(window.location.search)
  );

  const setSearchQuery = useCallback((query: string) => {
    const url = new URL(window.location.href);

    if (query.trim()) {
      url.searchParams.set('search', query);
    } else {
      url.searchParams.delete('search');
    }

    window.history.pushState({}, '', url.toString());
    setUrlSearchParams(new URLSearchParams(url.search));
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      setUrlSearchParams(new URLSearchParams(window.location.search));
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const searchQuery = urlSearchParams.get('search') || '';

  return [searchQuery, setSearchQuery] as const;
}
